<template>
  <div data-slot="leadgen-form-view" class="flex flex-col">
    <page-header
      :title="listComponent?.leadgenForm?.name ?? tr('Leads')"
      back="/leadgen-forms"
      :back-label="tr('Lead generation forms')"
    />

    <div class="flex flex-col gap-4 py-5">
      <leadgen-form-leads-header v-if="listComponent?.leadgenForm" :list-component="listComponent" />
      <div v-else class="flex flex-col gap-3">
        <ui-skeleton class="h-4 w-80 max-w-full" />
        <ui-skeleton class="h-6 w-64" />
      </div>

      <leadgen-form-leads-list
        ref="list"
        :leadgen-form-id="leadgenFormId"
        :lead-route-base="leadListPath + '/leads'"
      />
    </div>
  </div>
</template>

<script>
import LeadModalRouteMixin from '@/mixins/LeadModalRoute.js';
import LeadgenFormLeadsHeader from '@/ui/components/LeadgenFormLeadsHeader.vue';
import LeadgenFormLeadsList from '@/ui/components/LeadgenFormLeadsList.vue';
import PageHeader from '@/ui/components/PageHeader.vue';

export default {
  name: 'LeadgenFormView',
  components: {
    LeadgenFormLeadsHeader,
    LeadgenFormLeadsList,
    PageHeader,
  },
  mixins: [ LeadModalRouteMixin ],
  data: () => ({
    listComponent: null,
  }),
  computed: {
    leadgenFormId() {
      return this.$route.params.id;
    },
    leadListPath() {
      return '/leadgen-forms/' + this.leadgenFormId;
    },
  },
  mounted() {
    this.listComponent = this.$refs.list;
  },
};
</script>
